var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import css from '@styled-system/css';
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
});
const InnerCheckedRect = styled.div(({ checked, theme }) => css({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: checked ? 'checkbox.inner' : 0,
    height: checked ? 'checkbox.inner' : 0,
    backgroundColor: checked ? theme.colors.primaryActive : 'bg.regular',
    borderRadius: 'xxs',
    transition: theme.transitions.regular,
}), ({ checked, disabled, theme }) => disabled
    ? css({
        backgroundColor: checked ? theme.colors.primaryDisabled : 'bg.regular',
    })
    : {});
const OuterCheckboxRect = styled.div(({ checked, theme }) => css({
    position: 'relative',
    width: 'checkbox.outer',
    height: 'checkbox.outer',
    backgroundColor: 'bg.regular',
    border: 'thinSolid',
    borderColor: checked ? 'primary' : 'border.regular',
    borderRadius: 'xs',
    transition: theme.transitions.regular,
    ':hover': checked ? { boxShadow: 'inset 0 0 0 2px #ffe8ea' } : { boxShadow: 'inset 0 0 0 2px #eceff4' },
}), ({ checked, disabled, theme }) => disabled
    ? css({
        borderColor: checked ? theme.colors.primaryDisabled : 'border.disabled',
        backgroundColor: checked ? 'bg.default' : 'bg.blueGray',
        ':hover': { boxShadow: 'none' },
    })
    : undefined);
const CheckboxContainer = styled.div({
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'sub',
});
const CheckboxLabel = styled.span(({ disabled, hideLabel }) => hideLabel
    ? {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        width: 1,
    }
    : css({
        marginLeft: 3,
        lineHeight: 1.5,
        color: disabled ? 'text.label' : 'text.semiBold',
    }));
const CheckboxComp = (_a) => {
    var { checked = false, disabled = false, disableOnClick = false, outerRectStyles } = _a, props = __rest(_a, ["checked", "disabled", "disableOnClick", "outerRectStyles"]);
    return (React.createElement(CheckboxContainer, null,
        !disableOnClick && React.createElement(HiddenCheckbox, Object.assign({ checked: checked, disabled: disabled }, props)),
        React.createElement(OuterCheckboxRect, { checked: checked, disabled: disabled, style: outerRectStyles },
            React.createElement(InnerCheckedRect, { checked: checked, disabled: disabled }))));
};
const CheckboxWrapper = styled.label({
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
});
const Checkbox = (_a) => {
    var { disabled, label, hideLabel = false, disableOnClick = false, containerStyles, labelStyles } = _a, props = __rest(_a, ["disabled", "label", "hideLabel", "disableOnClick", "containerStyles", "labelStyles"]);
    return (React.createElement(CheckboxWrapper, { style: containerStyles },
        React.createElement(CheckboxComp, Object.assign({ disabled: disabled, disableOnClick: disableOnClick }, props)),
        React.createElement(CheckboxLabel, { hideLabel: hideLabel, disabled: disabled, style: labelStyles }, label)));
};
Checkbox.defaultProps = {
    disabled: false,
    checked: false,
    disableOnClick: false,
};
/**
 * @deprecated
 */
export default Checkbox;
